import React from 'react';
import { upperFirst } from 'lodash';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import AppointmentInfo from '../../shared/AppointmentInfo';
import ShopLocation from '../../shared/ShopLocation';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import Cta from './components/Cta';

/* eslint-disable react/prop-types */
const CustomerUnpaidAppointment = ({
  shop,
  date,
  customer,
  confirmationCode,
  barber,
  service,
  address,
  duration,
  appLink,
  squireInfoClassName,
}) => (
  <div>
    <Header shopName={shop.name} />
    <NotificationContent>
      <Logo />
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mt-12">
        Stay safe
      </div>
      <h2 className="u-text-huge u-fw-bold u-mt-2 u-mb-10">
        Hey {upperFirst(customer.firstName)}, avoid the hassle of having<br />to pay in person by paying now.
      </h2>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">
        Upcoming appointment
      </div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap">
        <AppointmentInfo
          confirmationCode={confirmationCode}
          barberName={`${barber.firstName} ${(barber.lastName || '')[0]}.`}
          service={service}
          date={date}
          duration={duration}
        >
          <a className="c-pay-now-button u-mt-8 u-text-medium" href={appLink} target="_blank">
            <span className="u-mr-2" />
            Pay now
          </a>
        </AppointmentInfo>
        <div className="c-appointment-info-divider u-hide-on-desktop" />
        <ShopLocation
          shopName={shop.name}
          phone={shop.phone}
          line1={address.line1}
          line2={address.line2}
          map={shop.staticMap.url}
          directions={address.directions}
        />
      </div>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withAppointmentNotification(CustomerUnpaidAppointment);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerUnpaidAppointment/index.jsx